import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ErrorModel } from '@awp/core/utils';

@Component({
  selector: 'ap-error-dialog',
  templateUrl: './error-dialog.component.html',
  host: {
    'class': 'ap-step',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { error: ErrorModel }) { }

}
